import React, {useState} from "react";
import {Box, Chip, Container} from "@mui/material";
import PageHeader from "../components/modern/PageHeader";
import SectionTitle from "../components/modern/SectionTitle";
import EventList, {EventRow} from "../components/modern/EventList";
import {today, useEvents} from "../data/sheet";
import {colors} from "../styling/GlobalTheme";

/* Calendrier complet (onglet "Evenements" du Google Sheet) */
function Activities() {
    const {data} = useEvents();
    const [type, setType] = useState("");
    const types = Array.from(new Set(data.filter(e => e.end >= today()).map(e => e.type).filter(Boolean)));
    const upcoming = data.filter(e => e.end >= today() && (!type || e.type === type));
    const past = data.filter(e => e.end < today()).reverse().slice(0, 6);

    return (
        <>
            <PageHeader title="Activités" subtitle="Camp, sorties, assemblée, courses et 25 ans du club : tout le programme de la saison."
                        image={process.env.PUBLIC_URL + "/images/2024mouchtec/mouch6.jpg"}/>
            <Box component="section" sx={{py: {xs: 6, md: 9}}}>
                <Container maxWidth="lg">
                    <SectionTitle kicker="Saison 2026 – 2027" title="À venir"/>
                    {types.length > 1 && (
                        <Box sx={{display: "flex", gap: 1, flexWrap: "wrap", mb: 3}}>
                            {["", ...types].map(t => (
                                <Chip key={t || "all"} label={t || "Tout"} clickable onClick={() => setType(t)}
                                      sx={{fontWeight: 700, bgcolor: type === t ? colors.night : "#fff", color: type === t ? "#fff" : colors.night}}/>
                            ))}
                        </Box>
                    )}
                    <EventList events={upcoming} emptyText="Le programme de la saison sera publié prochainement."/>
                    {past.length > 0 && <Box sx={{mt: 8, opacity: .8}}>
                        <SectionTitle title="Derniers événements"/>
                        {past.map((e, i) => <EventRow key={i} e={e} past/>)}
                    </Box>}
                </Container>
            </Box>
        </>
    );
}

export default Activities;
